export const creditcard = () => (
  <path
    d="M1 10h22M3 4h18a2 2 0 012 2v12a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
